import { gql } from "@apollo/client";

export const GETORDER = gql`
  query getOrder($order_id: Int!) {
    getOrder(id: $order_id) {
      id
      type
      status
      status_color
      subtotal
      total
      address {
        id
        address
        comments
        location
      }
      creation
      creation_date
      modification
      user_comments
      client_comments
      resume_txt
      delivery_type
      delivery
      payment_type
      card_type
      cash_income
      tip
      payed
      branch {
        id
        name
      }
      client {
        id
        name
        lastname
        phone
        email
        orders_count
      }
      user {
        id
        name
        lastname
      }
      table {
        id
        name
      }
      products {
        id
        status
        price
        ingredients_txt
        comments
        qty
        qty_done
        product {
          id
          title
          has_recipe
          category {
            id
            name
          }
          images {
            url
          }
        }
      }
      payments {
        id
        amount
        payment_type
        card_type
      }
    }
  }
`;

export const UPDATEORDER = gql`
  mutation updateOrder($order: UpdateOrderInput) {
    updateOrderTable(order: $order) {
      id
    }
  }
`;

export const UPDATETABLE = gql`
  mutation updateOrderTable($order: UpdateOrderInput) {
    updateOrderTable(order: $order) {
      id
    }
  }
`;

export const UPDATEORDERADDRESS = gql`
  mutation updateOrderAddress($order: UpdateOrderAddressInput!) {
    updateOrderAddress(order: $order) {
      id
      delivery
      total
      subtotal
      address {
        id
        address
        comments
        location
      }
    }
  }
`;

export const UPDATEPRODUCT = gql`
  mutation updateOrderProduct($product: UpdateOrderProductInput) {
    updateOrderProduct(product: $product) {
      id
    }
  }
`;
export const ALLPRODUCTSDONE = gql`
  mutation allProductsDone($order_id: ID!) {
    allProductsDone(order_id: $order_id)
  }
`;

export const PAYORDER = gql`
  mutation payOrder($payment: PaymentInput) {
    payOrder(payment: $payment) {
      id
      payed
      cash_income
      tip
      total
      payments {
        id
        amount
        payment_type
        card_type
      }
    }
  }
`;

export const PAY_SPLIT_ORDER = gql`
  mutation paySplitOrder($payment: SplitPaymentInput!) {
    paySplitOrder(payment: $payment) {
      id
      payed
      cash_income
      tip
      total
      payments {
        id
        amount
        payment_type
        card_type
      }
    }
  }
`;

export const ADD_TIP = gql`
  mutation addTip($order_id: Int!, $tip: Float!) {
    addTip(order_id: $order_id, tip: $tip) {
      id
      tip
    }
  }
`;

export const SAVETOKEN = gql`
  mutation saveToken($token: String!) {
    saveToken(token: $token)
  }
`;

export const CREATE_PAYMENT_LINK = gql`
  mutation CreatePaymentLink(
    $amount: Float!
    $description: String!
    $customer_email: String!
    $customer_name: String
  ) {
    createPaymentLink(
      amount: $amount
      description: $description
      customer_email: $customer_email
      customer_name: $customer_name
    ) {
      paymentLink {
        id
        amount
        description
        customer_email
        checkout_url
        status
      }
      emailSent
    }
  }
`;
